const international = [
    {
    id: "international-yoga-day",
    date: "06-21",
    category: "health",
    title: "International Yoga Day",
    description: `International Yoga Day promotes physical, mental, 
    and spiritual well-being through the practice of yoga. 
    It highlights the importance of harmony between body and mind 
    for a balanced and healthy life.`,
    color: "#2E7D32"
  },
  {
    id: "international-day-of-happiness",
    date: "03-20",
    category: "awareness",
    title: "International Day of Happiness",
    description: `The International Day of Happiness recognizes happiness and well-being as universal goals. It encourages positive thinking, kindness, and global unity across cultures and communities.`,
    color: "#F59E0B"
  },

  {
    id: "international-day-of-forests",
    date: "03-21",
    category: "environment",
    title: "International Day of Forests",
    description: `This day promotes the conservation and sustainable management of forests. Forests play a vital role in biodiversity, climate balance, and supporting livelihoods worldwide.`,
    color: "#166534"
  },

  {
    id: "world-water-day",
    date: "03-22",
    category: "environment",
    title: "World Water Day",
    description: `World Water Day highlights the importance of freshwater and sustainable water management. It raises awareness about global water challenges and conservation efforts.`,
    color: "#0284C7"
  },

  {
    id: "international-day-of-education",
    date: "01-24",
    category: "education",
    title: "International Day of Education",
    description: `This day emphasizes education as a fundamental human right. It promotes equal access to quality learning opportunities for individuals worldwide.`,
    color: "#1D4ED8"
  },

  {
    id: "world-creativity-and-innovation-day",
    date: "04-21",
    category: "innovation",
    title: "World Creativity and Innovation Day",
    description: `This day celebrates the power of creativity and innovation in solving global challenges. It encourages new ideas that drive sustainable development.`,
    color: "#7C3AED"
  },

  {
    id: "international-day-of-peace",
    date: "09-21",
    category: "peace",
    title: "International Day of Peace",
    description: `The International Day of Peace promotes harmony and non-violence across nations. It inspires dialogue, understanding, and peaceful cooperation.`,
    color: "#2563EB"
  },

  {
    id: "world-oceans-day",
    date: "06-08",
    category: "environment",
    title: "World Oceans Day",
    description: `World Oceans Day celebrates marine ecosystems and promotes sustainable ocean practices. Oceans are essential for climate balance and biodiversity.`,
    color: "#0369A1"
  },

  {
    id: "international-day-of-democracy",
    date: "09-15",
    category: "governance",
    title: "International Day of Democracy",
    description: `This day highlights the importance of democratic principles such as participation, equality, and accountability in governance systems worldwide.`,
    color: "#334155"
  },

  {
    id: "international-day-of-human-rights",
    date: "12-10",
    category: "awareness",
    title: "Human Rights Day",
    description: `Human Rights Day commemorates the adoption of the Universal Declaration of Human Rights. It promotes dignity, equality, and justice for all people.`,
    color: "#991B1B"
  },

  {
    id: "world-refugee-day",
    date: "06-20",
    category: "awareness",
    title: "World Refugee Day",
    description: `World Refugee Day honors the strength and resilience of displaced individuals. It encourages global solidarity and support for humanitarian efforts.`,
    color: "#EA580C"
  },

  {
    id: "international-day-of-friendship",
    date: "07-30",
    category: "culture",
    title: "International Day of Friendship",
    description: `This day celebrates friendship as a bridge between communities and cultures. It promotes understanding, respect, and global peace.`,
    color: "#EC4899"
  },

  {
    id: "world-tourism-day",
    date: "09-27",
    category: "culture",
    title: "World Tourism Day",
    description: `World Tourism Day promotes sustainable tourism and cultural exchange. It highlights tourism’s role in economic growth and global connection.`,
    color: "#0E7490"
  },

  {
    id: "international-day-of-youth",
    date: "08-12",
    category: "awareness",
    title: "International Youth Day",
    description: `International Youth Day recognizes the potential and leadership of young people worldwide. It encourages youth engagement in shaping the future.`,
    color: "#8B5CF6"
  },

  {
    id: "world-heritage-day",
    date: "04-18",
    category: "culture",
    title: "World Heritage Day",
    description: `World Heritage Day raises awareness about preserving cultural and natural heritage sites. It promotes global appreciation of shared history.`,
    color: "#B45309"
  },

  {
    id: "international-day-of-light",
    date: "05-16",
    category: "science",
    title: "International Day of Light",
    description: `This day highlights the importance of light in science, culture, and sustainable development. It celebrates innovation in optics and energy.`,
    color: "#FACC15"
  },

  {
    id: "world-post-day",
    date: "10-09",
    category: "communication",
    title: "World Post Day",
    description: `World Post Day recognizes the role of postal services in global communication. It celebrates connectivity across communities worldwide.`,
    color: "#1E3A8A"
  },

  {
    id: "international-day-of-non-violence",
    date: "10-02",
    category: "peace",
    title: "International Day of Non-Violence",
    description: `This day promotes peaceful conflict resolution and non-violent action. It encourages dialogue, tolerance, and mutual respect.`,
    color: "#475569"
  },

  {
    id: "world-population-day",
    date: "07-11",
    category: "awareness",
    title: "World Population Day",
    description: `World Population Day highlights global population trends and sustainable development challenges. It promotes informed decision-making for the future.`,
    color: "#0F766E"
  },

  {
    id: "international-day-of-mother-language",
    date: "02-21",
    category: "culture",
    title: "International Mother Language Day",
    description: `This day promotes linguistic diversity and multilingual education. It encourages preservation of native languages and cultural identity.`,
    color: "#9333EA"
  },

  {
    id: "world-science-day",
    date: "11-10",
    category: "science",
    title: "World Science Day for Peace and Development",
    description: `World Science Day emphasizes the role of science in society. It encourages research, innovation, and international scientific cooperation.`,
    color: "#0F172A"
  }
];

export default international;